// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getWarrantyExpirationColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'model',
            field: 'model',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MODEL'),
            width: 120
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'description',
            field: 'description',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DESCRIPTION'),
            width: 120
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'dealer',
            field: 'dealer',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerName',
            field: 'dealerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerCity',
            field: 'dealerCity',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_CITY'),
            width: 160
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customerName',
            field: 'customerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER_NAME'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'phone',
            field: 'phone',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PHONE'),
            width: 160
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'street1',
            field: 'street1',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STREET_1'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'street2',
            field: 'street2',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STREET_2'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'postalCode',
            field: 'postalCode',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('POSTAL_CODE'),
            width: 120
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'city',
            field: 'city',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CITY'),
            width: 160
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'region',
            field: 'region',
            headerClass: classNames.headerClassName,
            headerName: translate('REGION'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'country',
            field: 'country',
            headerClass: classNames.headerClassName,
            headerName: translate('COUNTRY'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'email',
            field: 'email',
            headerClass: classNames.headerClassName,
            headerName: translate('EMAIL'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'startDate',
            field: 'startDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('BASIC_WARRANTY_STARTS'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'expirationDate',
            field: 'expirationDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('EXPIRES'),
            width: 130
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'warrantyHoursLimit',
            field: 'warrantyHoursLimit',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('TIME_LIMIT'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'warrantyType',
            field: 'warrantyType',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('WARRANTY_TYPE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'coverageType',
            field: 'coverageType',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('COVERAGE_TYPE'),
            width: 180
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'contractPurchaseDate',
            field: 'contractPurchaseDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('CONTRACT_PURCHASED'),
            width: 160
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/report-services/column-definitions.js